import qs from 'qs';

const Exhibition = {
    namespaced: true,

    state: {
        exhibitionData: [],
    },

    getters: {
        exhibitionData (state) {
            return state.exhibitionData;
        },
    },

    mutations: {
        /**
         * Установить значение должности
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['exhibitionData'] = items;
        },

        /**
         * Обновить значение элемента должности
         * @param state
         * @param item
         * @param index
         */
        setItem (state, { item, index }) {
            state['exhibitionData'][index] = item;
        },

        /**
         * Добавить значение элемента должности
         * @param state
         * @param item
         */
        addItem (state, { item }) {
            state['exhibitionData'].push(item);
        },

        /**
         * Удалить элемент из должности
         * @param state
         * @param item
         */
        remove (state, { item }) {
            state['exhibitionData'] = state['exhibitionData'].filter(iItem => iItem !== item);
        },
    },


    actions: {
        /**
         * Получение данных по мероприятиям
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getExhibitionData ({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                axios({
                    url: rootGetters.rootUrl + 'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.exhibition,
                    }),
                }).then(response => (
                    commit('setArr', {
                        items: response.data
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по мероприятиям получены.'),
                    resolve(response)
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true}),
                    console.log('ERROR IN exhibition.js | getExhibitionData: ' + err);
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных по мероприятиям!'),
                    reject(err);
                });
            })
        },

        /**
         * Сохранение данных по мероприятиям
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        saveExhibitionData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});

                const str = JSON.stringify(data.data);

                axios({
                    url: rootGetters.rootUrl + 'list/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.exhibition,
                    }),
                }).then(response => {
                    // Если редактирование
                    if (data.index !== -1) {
                        commit('setItem', {
                            item: data.data,
                            index: data.index
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по мероприятиям успешно отредактированы!');
                    // Если сохранение нового
                    } else {
                        data.data.id = response.data[0].id;

                        commit('addItem', {
                            item: data.data
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Новое мероприятие успешно создано!');
                    }
                    resolve(response);
                }).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных!');
                    console.log('ERROR IN exhibition.js | saveExhibitionData: ' + err);
                    reject(err);
                })
            })
        },

        /**
         * Удаление мероприятия
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        removeExhibitionData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});

                const str = JSON.stringify(data.item);
                
                axios({
                    url: rootGetters.rootUrl + 'list/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.exhibition,
                    }),
                }).then(response => (
                    commit('remove', {
                        item: data.item
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Мероприятие успешно удалено!'),
                    resolve(response)
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении мероприятия!'),
                    console.log('ERROR IN exhibition.js | removeExhibitionData: ' + err);
                    reject(err);
                });
            })
        },
    },
};

export default Exhibition;


// WEBPACK FOOTER //
// ./src/store/modules/exhibition.js